import { Component, OnInit, OnDestroy } from '@angular/core';
import { LogoutService } from 'src/app/services/LogoutService/logout-service.service';
import { SalesService } from 'src/app/services/SalesService/sales-service.service';
import { RequestDayInfoService } from 'src/app/services/StoreService/RequestDayInfoService/request-day-info-service.service';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sale-kind-versions',
  templateUrl: './sale-kind-versions.component.html',
  styleUrls: ['./sale-kind-versions.component.scss']
})
export class SaleKindVersionsComponent implements OnInit, OnDestroy {

  constructor(
    private salesService: SalesService,
    private requestDayInfoService: RequestDayInfoService,
    private logoutService: LogoutService,
    private router: Router,
    private store: Store<{ channel: string }>
  ) {

    this.storeSubscription = this.store.subscribe(state => {
      this.channel = state.channel;
      if(this.channel == "CP"){
        this.router.navigate(["/pv/request-day"]);
      }
    })
  }

  displayedColumns: string[] = ['fecha', 'version', 'plantilla', 'estado', 'ambiente'];

  storeSubscription: Subscription;
  observable: Subscription;
  channel: string = "CNP";

  data: any;

  pageLoader = true;
  errorMessage = false;

  pageSizeOptions: number[] = [5, 10, 15, 20];
  pageSize: number = 10;
  lowValue: number = 0;
  highValue: number = 10;

  actualPage: number;

  totalPages: number;
  totalElements: number;

  ngOnInit(): void {
    if(this.channel != "CNP"){
      this.router.navigate(["/pv/request-day"]);
    }
    this.actualPage = 1;
    this.request();
  }

  ngOnDestroy(): void {
    if(this.observable){
      this.observable.unsubscribe();
    }

    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
  }

  request(){
    this.pageLoader = true;
    this.errorMessage = false;
    this.observable = this.salesService.getSaleKindVersions(this.actualPage)
      .subscribe((data:any) => {
        this.data = data.sales;
        this.totalPages = data.totalPages;
        this.totalElements = data.totalItems;
        this.pageLoader = false;
      }, error => {
        if (error.status == 401) {
          this.logoutService.logout();
        };

        this.pageLoader = false;
        this.errorMessage = true;
      })
  }

  tryAgain(){
    this.request();
  }

  newRequest(){
    this.actualPage = this.requestDayInfoService.getActualPage();
    this.request();
  }

  getPaginatorData(event) {
    this.lowValue = event.pageIndex * event.pageSize;
    this.highValue = this.lowValue + event.pageSize;
    return event;
  }
}
